<script setup lang="ts">
import type { AccordionItem } from '@nuxt/ui'

const article = inject(keys.currentArticle)

const accordions = computed(() => {
  if (article?.contentType !== 'article' || !article.accordion) {
    return []
  }

  const groups: Record<string, AccordionItem[]> = {}

  let currentGroup = 'default'
  for (const item of article.accordion) {
    if (item.groupTitle) {
      currentGroup = item.groupTitle
    }

    groups[currentGroup] ??= []
    groups[currentGroup]!.push({
      label: item.title,
      content: item.content,
    })
  }

  return Object.entries(groups).map(([title, items]) => ({
    title,
    items,
  }))
})
</script>

<template>
  <div v-if="accordions.length" class="mt-6 flex flex-col gap-2">
    <div
      v-for="accordion in accordions"
      :key="accordion.title"
    >
      <h3
        v-if="accordion.title !== 'default'"
        class="mt-10 mb-4"
        v-text="accordion.title"
      />

      <UAccordion
        :items="accordion.items"
        :ui="{
          root: 'text-green-50',
          item: 'bg-white py-4',
        }"
      >
        <template #content="{ item }">
          <div v-html="item.content" />
        </template>
      </UAccordion>
    </div>
  </div>
</template>
